import { render, staticRenderFns } from "./BudgetNotes.vue?vue&type=template&id=fa098e58"
import script from "./BudgetNotes.vue?vue&type=script&lang=js"
export * from "./BudgetNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports